import { useRef, type ReactNode, type CSSProperties } from "react";
import { useIntersection } from "@/hooks/useIntersection";

const prefersReducedMotion =
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

interface FadeInProps {
  children: ReactNode;
  delay?: number;
  style?: CSSProperties;
  className?: string;
}

export default function FadeIn({ children, delay = 0, style = {}, className }: FadeInProps) {
  const ref = useRef<HTMLDivElement>(null);
  const visible = useIntersection(ref);

  // Respect OS-level motion preference — show immediately, no animation
  if (prefersReducedMotion) {
    return <div className={className} style={style}>{children}</div>;
  }

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(10px)",
        transition: `opacity 0.45s ease ${delay}s, transform 0.45s ease ${delay}s`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
